
    import {Component, Prop, Vue} from 'vue-property-decorator';
    import {IconRegistry} from '@/lib/IconRegistry';
    import Branch from "../lib/Branch";

    @Component(
        {
            components: {},
        },
    )
    export default class Default extends Vue {
        public homeUrl = process.env.VUE_APP_HOME;
        public backendUrl = process.env.VUE_APP_BACKEND_URL;
        public insurer = null;
        public targetedBranch = null;


        mounted() {
            this.insurer = this.$store.state.insurerLock;
            this.targetedBranch = this.$store.state.branches.find((branch: Branch) => {
                return branch.slug === 'habitation';
            });

        }

        unsetLogo() {
            this.insurer.logo = null;
            // console.log('unset logo');
        }

        destroy() {
        }

        public getIcon(iconName: string) {
            return '/static/' + IconRegistry.getIcon('branch', iconName);
        }

    }
